// URL base del backend Neko-CLI (status, manutenzione, rating, changelog).
// Configurabile in produzione tramite REACT_APP_API_URL nel .env del frontend.
export const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4000";
